var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('base-card',[_c('v-img',{attrs:{"src":_vm.banner.src,"lazy-src":_vm.banner.src,"width":"100%"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('BaseImageLoading')]},proxy:true}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }